export default __webpack_public_path__ + "static/media/Legguards of the Renegade.d60acd8d.jpg";